<eo-base-form-control
  [styleClass]="getStyleClass()"
  [label]="getLabel()"
  [help]="getHelp()"
  [errors]="getErrors()"
  [notApplicableLabel]="notApplicableLabel"
  [canBeNotApplicable]="canBeNotApplicable"
  [notApplicable]="notApplicable"
  (onRemove)="onRemoveHandler()"
  (onChange)="onChangeHandler($event)"
  (onBlur)="onBlurHandler($event)"
  (onFocus)="onFocusHandler($event)"
>
  <p-pickList
    dragdrop
    responsive
    styleClass="mt-1"
    breakpoint="720px"
    [sourceHeader]="sourceHeader"
    [targetHeader]="targetHeader"
    [source]="source"
    [target]="target"
    [sourceStyle]="{ height: '18rem' }"
    [targetStyle]="{ height: '18rem' }"
    [showSourceControls]="false"
    [showTargetControls]="false"
    (onMoveToSource)="onPicklistChange()"
    (onMoveToTarget)="onPicklistChange()"
    (onMoveAllToSource)="onPicklistChange()"
    (onMoveAllToTarget)="onPicklistChange()"
  >
    <ng-template let-item pTemplate="item">
      {{ item[optionLabel] ?? "-" }}
    </ng-template>
  </p-pickList>
</eo-base-form-control>